import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0473a248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex sm12" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-0473a248><p class=\"flex sm12 pb-2\" data-v-0473a248> To subscribe to Telegram, you must start the process from your Telegram account: </p></div><div class=\"row pb-2\" data-v-0473a248><div class=\"flex sm12\" data-v-0473a248> 1. Start a new conversation with <a href=\"https://t.me/bsileo_bot\" target=\"_blank\" data-v-0473a248>@Notifi_bot</a></div></div><div class=\"row\" data-v-0473a248><div class=\"flex sm12\" data-v-0473a248>2. Send this message to the bot: <br data-v-0473a248></div></div>", 3)
const _hoisted_5 = { class: "row pb-2" }
const _hoisted_6 = { class: "copy ml-4 pr-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "flex sm12" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 3.")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Click Here ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("to detect this message and configure the details in Notifi. ")
const _hoisted_12 = { class: "row pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.userTag) + " ", 1),
        _createVNode(_component_va_icon, {
          onClick: _ctx.copyCode,
          class: "copyIcon",
          name: "content_copy"
        }, null, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_va_button, { onClick: _ctx.runPoll }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_va_input, {
        class: "mb-4",
        modelValue: _ctx.userID,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userID) = $event)),
        label: "Telegram UserID",
        disabled: !this.userID,
        readonly: "",
        placeholder: "@telegram"
      }, null, 8, ["modelValue", "disabled"])
    ])
  ]))
}